import styled from 'styled-components';

export const RadioButtonContainer = styled.input``;

RadioButtonContainer.displayName = 'RadioButtonContainer';
